function footer() {
  return (
    <footer>
      <div className="row">
        <div className="col s12 m12 l12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Copyright &copy; 2026 Kipling C. Dunlap</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default footer;